import { Component, OnInit } from '@angular/core';
import { CoreService } from 'src/app/core/helpers/core.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'loyaltic-fbsharesuccess',
  templateUrl: './fbsharesuccess.component.html',
  styleUrls: ['./fbsharesuccess.component.scss']
})
export class FbsharesuccessComponent implements OnInit {
userId = '';

constructor(private coreService: CoreService, private route: ActivatedRoute) {
    this.route.queryParams.subscribe(params => {
      this.userId = params['userId'];
    });
  }

  ngOnInit() {
    this.postFbShareSuccess();
  }


  postFbShareSuccess() {
    this.coreService.fbShareSuccess(this.userId).then(res => {

    });
  }

}
